//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stars from './_stars'
import Facilities from './_facilities'
import F2 from '@antv/f2'

export default {
    props: {
        plate: {
            type: Object
        },
        pid: {
            type: [String, Number]
        }
    },
    components: {
        Stars,
        Facilities
    },
    data () {
        return {
            canvasEl: null,
            chart: null
        }
    },
    watch: {
        plate (plate) {
            if (plate && plate.name && plate.ratings) {
                this.initChart(plate.name, plate.ratings)
            }
        }
    },
    methods: {
        initChart (name, ratings) {
            const node = document.querySelector(`#chart`)
            const { width, height } = node.style
            const context = node.getContext('2d')
            const pixelRatio = wx.getSystemInfoSync().pixelRatio
            // 高清设置
            node.width = width * pixelRatio
            node.height = height * pixelRatio
            const config = { context, width, height, pixelRatio }
            const chart = new F2.Chart({
                ...config
            })
            chart.coord('polar')
            const data = ['交通', '教育', '医院', '购物', '环境'].map((key) => {
                return {
                    item: key + ratings[key],
                    user: name,
                    score: Number(ratings[key])
                }
            })
            chart.source(data, {
                score: {
                    min: 0,
                    max: 5,
                    nice: true,
                    tickCount: 2
                }
            })
            chart.legend(false)
            chart.axis('score', {
                label: function label() {
                    return null
                },
                grid: function grid(text) {
                    return {
                        stroke: 'rgba(255, 255, 255, .5)',
                        lineWidth: 2,
                        lineDash: null
                    }
                }
            })
            chart.axis('item', {
                label: () => {
                    return {
                        fill: '#333',
                        fontSize: 14
                    }
                },
                grid: {
                    stroke: 'rgb(113, 113, 112)',
                    lineWidth: 1,
                    strokeOpacity: 0.4,
                }
            })
            chart.area().position('item*score').color('user')
                .style({
                    fill: 'rgba(53,189,162,.7)',
                    stroke: '#35BDA2',
                    lineWidth: 1,
                    fillOpacity: 1
                })
                .animate({
                    appear: {
                        animation: 'groupWaveIn'
                    }
                })
            chart.render()
            if (chart) {
                this.chart = chart;
                this.canvasEl = chart.get('el');
            }

        }
    }
}
